import { DateInput } from '@framework/form/inputs/DateInput.tsx';
import { NumberInput } from '@framework/form/inputs/NumberInput.tsx';
import { MenuPresets } from '@framework/form/inputs/rich-text/menu/MenuPresets.tsx';
import { RichTextInput } from '@framework/form/inputs/rich-text/RichTextInput.tsx';
import { SwitchInput } from '@framework/form/inputs/SwitchInput.tsx';
import { TextInput } from '@framework/form/inputs/TextInput.tsx';
import { Datatype } from '../../../../../expressions/datatype/Datatype.ts';
import { type IAdvancedSelectColumns } from '../IAdvancedSelectColumns.ts';

/**
 * Ritorna il componente di input appropriato in base al tipo di colonna
 */
export function getColumnInput(column: IAdvancedSelectColumns) {
  const inputName = `values.${column.id}`;

  switch (column.type) {
    case Datatype.Date:
      return (
        <DateInput
          name={inputName}
          placeholder={`Seleziona la data per ${column.label}...`}
        />
      );

    case Datatype.Number:
      return (
        <NumberInput
          name={inputName}
          placeholder={`Inserisci il valore per ${column.label}...`}
        />
      );

    case Datatype.Boolean:
      return <SwitchInput name={inputName}>{column.label}</SwitchInput>;
    case Datatype.RichText:
      return (
        <RichTextInput
          name={inputName}
          menus={MenuPresets.BlockWithoutTitle}
          rows={4}
        />
      );
    case Datatype.String:
    default:
      return (
        <TextInput
          name={inputName}
          placeholder={`Inserisci il valore per ${column.label}...`}
        />
      );
  }
}
